import { Record } from 'immutable';

import { EntityListEntity } from '../components/entity-list/entity-list.entity';

export const EntitySliceKey = 'main';

export interface IEntityOriginalSliceState {
	loading: boolean;
	actionInProgress: boolean;
	list: EntityListEntity;
}

export const defaults: IEntityOriginalSliceState = {
	loading: false,
	actionInProgress: false,
	list: EntityListEntity.build([]),
};

export class EntityOriginalSliceState extends Record<IEntityOriginalSliceState>(
	defaults
) {
	public static readonly key = EntitySliceKey;

	public setLoading(isLoading: boolean): EntityOriginalSliceState {
		return this.set('loading', isLoading);
	}

	public setActionInProgress(
		isActionInProgress: boolean
	): EntityOriginalSliceState {
		return this.set('actionInProgress', isActionInProgress);
	}

	public setEntityList(entityList: EntityListEntity): EntityOriginalSliceState {
		return this.set('list', entityList);
	}
}
